import React from "react";

import HeroBanner from "../components/landing/heroBanner.comp";
import bannerCore from "../core/banner.core";
import { useTranslation } from "../core/translation.core";
import { BannerListRes } from "../types/banner";
import MainLayout from "../components/layout/MainLayout";
import ProductCategorySection from "../components/categories/ProductCategorySection.comp";

// Define the props interface with proper types
interface HomePageProps {
  headerBannerListRes: BannerListRes[];
  footerBannerListRes: BannerListRes[];
}

export default function HomePage({ headerBannerListRes }: HomePageProps) {
  const { t, msg } = useTranslation();

  return (
    <MainLayout title={t(msg.menu.home)} url="/" description="">
      <HeroBanner headerBannerListRes={headerBannerListRes || []} />

      <main className="w-full px-0 lg:px-8 bg-guru-floral-white">
        <div className="max-w-7xl mx-auto">
          <ProductCategorySection />
        </div>
      </main>
    </MainLayout>
  );
}

export async function getServerSideProps({ locale, res }) {
  try {
    // Fetch banners with error handling - explicitly type the variables
    let headerBannerListRes: BannerListRes[] = [];
    let footerBannerListRes: BannerListRes[] = [];

    try {
      headerBannerListRes = await bannerCore.getBannerList("header", locale);
    } catch (error) {
      console.error("Error fetching header banners:", error);
      // Continue with empty array
    }

    try {
      footerBannerListRes = await bannerCore.getBannerList("footer", locale);
    } catch (error) {
      console.error("Error fetching footer banners:", error);
      // Continue with empty array
    }

    res.setHeader("Cache-Control", "public, s-maxage=360, stale-while-revalidate=360");

    return {
      props: {
        headerBannerListRes,
        footerBannerListRes,
      },
    };
  } catch (error) {
    console.error("Error in getServerSideProps:", error);

    return {
      props: {
        headerBannerListRes: [],
        footerBannerListRes: [],
      },
    };
  }
}
